export const cloudAccountConfigurationAwsSecurityGroupsKeys = {
  SecurityGroupForComputeNode: 'Restore server',
  SecurityGroupForRdsInstance: 'Restored RDS instance',
};
